/**
 * Case 级 Δ 召回率四档分桶（mock v3 第五段），点击可筛选下方 case 明细。
 *
 * 档位边界与后端 ``perception_report_service.classify_delta`` 严格对应，改一侧必须
 * 同步改另一侧——文案里写出边界值是为了让「正好 +2pp 落哪档」在页面上就能确认，
 * 不用回去翻代码。
 */
import { Tooltip } from 'antd';

import type { PerceptionDeltaBucket, PerceptionDeltaBuckets } from '@/apis/simulation';

/** 四档的展示定义。顺序即页面从左到右的顺序（改善 → 恶化）。 */
export const BUCKET_DEFS: {
  key: PerceptionDeltaBucket;
  label: string;
  hint: string;
}[] = [
  { key: 'improved', label: '明显改善', hint: 'Δ召回率 ≥ +2pp（正好 +2pp 落此档）' },
  { key: 'slightlyImproved', label: '轻微改善', hint: 'Δ召回率 ∈ [0, +2pp)（正好 0 落此档）' },
  { key: 'slightlyDegraded', label: '轻微恶化', hint: 'Δ召回率 ∈ (-2pp, 0)' },
  { key: 'degraded', label: '明显恶化', hint: 'Δ召回率 ≤ -2pp（正好 -2pp 落此档）' },
];

interface DeltaBucketCardsProps {
  buckets: PerceptionDeltaBuckets;
  /** 当前选中的档位；null = 未筛选 */
  active: PerceptionDeltaBucket | null;
  onSelect: (bucket: PerceptionDeltaBucket | null) => void;
}

export default function DeltaBucketCards({
  buckets,
  active,
  onSelect,
}: DeltaBucketCardsProps) {
  return (
    <div className="pe-buckets">
      {BUCKET_DEFS.map((def) => (
        <div
          key={def.key}
          className={[
            'pe-bucket',
            `pe-bucket--${def.key}`,
            active === def.key ? 'pe-bucket--active' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          onClick={() => onSelect(active === def.key ? null : def.key)}
        >
          <div className="pe-bucket-label">
            <Tooltip title={def.hint}>{def.label}</Tooltip>
          </div>
          <div className="pe-bucket-value">{buckets[def.key]}</div>
        </div>
      ))}
    </div>
  );
}
